var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5,3a13.99,13.99,0,0,0-14,14c0,10.5,14,26,14,26s14-15.5,14-26A13.99,13.99,0,0,0,21.5,3Zm0,19a5,5,0,1,1,5-5A5,5,0,0,1,21.5,22Z","transform":"translate(-7.5 -3)","fill":"#3b3b3b"}));
}

Location.defaultProps = {"width":"28","height":"40","viewBox":"0 0 28 40"};

module.exports = Location;

Location.default = Location;
